import React, { useState, useEffect, useCallback } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import Table from "../../Shared/Table";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import Chip from "../../Shared/StatusChip";
import { PrimaryButton } from "../../Shared/Buttons";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ReqListActions } from "../../Store/Reducers/NewReqList-reducer";
import getRestauarntList from "../../Store/Actions/GetNewReqList-Action";
import { BtnStyle } from "../../Util/CSS/BtnStyle";
import ModalComp from "../../Shared/ModalComp";
import ReqEdit from "../NewReqEdit/ReqEdit";
import NewRequestDetails from "./NewRequestDetails";
import AddRestaurant from "../AddRestaurant/AddRestaurant";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
import { useErrorHandler } from "react-error-boundary";
const NewRequests = () => {
  const { reqList, isLoading, status, isLoaded, lastEvaluatedkey, loadMore } =
    useSelector((state) => state.restReqList);
  const { restaurantData } = useSelector((state) => state.Restaurant);

  const dispatch = useDispatch();
  const styles = BtnStyle();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [reqId, setReqId] = useState("");
  const [openAddNewRestaurant, setOpenAddNewRestaurant] = useState(false);
  const ErrorHandler = useErrorHandler();
  const [NewReqDetails, setNewReqDetails] = useState({
    RestName: "",
    emailId: "",
  });
  const handleClose = () => {
    setopenModal(!openModal);
  };
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const addNewRestaurantCloseHandler = () => {
    setOpenAddNewRestaurant(false);
  };
  useEffect(() => {
    if (!isLoaded) {
      dispatch(ReqListActions.setIsLoaded(true));
      dispatch(getRestauarntList(lastEvaluatedkey));
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [isLoaded]);

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
      handleSnackbarOpen(status, "errorDark");
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [status]);

  const [modalItemId, setModalItemId] = useState("");
  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };
  const handleModal = (id) => {
    setModalItemId(id);
    setopenModal(true);
  };
  const TableData = (data) => {
    let tableValues = data.map((item, index) => ({
      contact_person: item.owner_name ? item.owner_name : "—",
      request_time: item.requst_time ? getTime(item.requst_time) : "—",
      number: item.number ? item.number : "—",
      email: item.email ? item.email : "—",
      rest_name: item.rest_name ? item.rest_name : "—",
      lead_status: item.lead_status ? (
        <Chip
          index={index}
          setLoading={() => () => dispatch(ReqListActions.setLoading(false))}
          handleSnackbarOpen={handleSnackbarOpen}
          data={reqList}
          comp="new_requests"
          statusKey="lead_status"
          itemId={item.id}
        />
      ) : (
        ""
      ),
      add_restaurant: (
        <PrimaryButton
          size="small"
          style={{ width: "100px" }}
          testId={`add_rest_${item.id}`}
          handleClick={() => {
            setNewReqDetails({ RestName: item.rest_name, emailId: item.email });
            setOpenAddNewRestaurant(true);
          }}
        >
          Add
        </PrimaryButton>
      ),
      details: <NewRequestDetails id={item.id} />,
    }));
    return tableValues;
  };

  const columns = [
    {
      name: "contact_person",
      label: "Contact Person",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "request_time",
      label: "Request Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "number",
      label: "Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "rest_name",
      label: "Restaurant Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "lead_status",
      label: "Lead Status",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "add_restaurant",
      label: "Add Restaurant",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "details",
      label: "Details",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const onRowsDelete = (rows) => {
    return false;
  };

  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      lastEvaluatedkey.id &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      dispatch(getRestauarntList(lastEvaluatedkey));
      return;
    }
  };
  return (
    <>
      {isLoading ? (
        <LoadingScreen loading={isLoading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          <Table
            data={TableData(reqList)}
            columns={columns}
            title="New Requests"
            onRowsDelete={onRowsDelete}
            onTableChange={onTableChangeHandler}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
          {openAddNewRestaurant && (
            <ModalComp
              open={openAddNewRestaurant}
              handleClose={addNewRestaurantCloseHandler}
              top={100}
              topMobile={100}
              width={700}
              minHeight={400}
            >
              <AddRestaurant
                modalClose={addNewRestaurantCloseHandler}
                NewReqDetails={NewReqDetails}
                restData={restaurantData}
              />
            </ModalComp>
          )}
        </>
      )}

      {openModal && (
        <ReqEdit
          open={openModal}
          handleClose={handleClose}
          id={reqId}
          top={100}
          topMobile={100}
          width={700}
          minHeight={400}
        />
      )}
    </>
  );
};

export default NewRequests;
